<template>
  <div class="table_block">
    <Table
      :loading="loading"
      border
      stripe :columns="columns"
      :data="table.data"
      size="small"
      :height="table.height"
      disabled-hover
      highlight-row
      @on-selection-change="selectionChange"
      @on-row-click="onRowClick"
    ></Table>

    <RouterModel ref="routerModal"></RouterModel>
  </div>
</template>

<script>
import helper from "@/utils/helper.js";
import RouterModel from "@/components/RouterModal.vue";

export default {
  name: "NormalTable",
  components: { RouterModel },
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    apiUrl: {
      type: [Number, String],
    },
    search: {
      type: Object,
    },
  },
  data: function () {
    return {
      loading: false,
      count_all41:null,
      table: {
        data: [],
        height: 0,
      },
      pagination: {
        total: 0,
        sizes: [10, 20, 30, 50],
        search: {
          PageIndex: 1,
          PageSize: 10,
        },
      },
    };
  },
  // created: function () {
  //   this.load();
  // },
  methods: {
    //表格
    load: function () {
      //合并搜索条件
      this.loading = true;
      var temp = Object.assign({}, this.search, this.pagination.search);
      
      this.$api.get(this.apiUrl, temp).then((rsp) => {
        if (rsp != false) {
          this.table.data = rsp.data;
          // console.log('请求的表格数据',this.table.data);
          this.loading = false;
        }
      });
    },

    initload: function () {
      //合并搜索条件
      this.loading = true;
      this.pagination.search.PageIndex = 1;
      var temp = Object.assign({}, this.search, this.pagination.search);
      this.$api.get(this.apiUrl, temp).then((rsp) => {
        this.table.data = rsp.data;
        this.loading = false;
      });
    },
    // 工作量统计的方法
    initload22: function (type=0) {
      if ( !this.search.RequestDepartment) {
        if(type) this.$Message.error("您未选择医院或科室");
      }else{
        
        //合并搜索条件
        this.loading = true;
        this.pagination.search.PageIndex = 1;
        // console.log('this.sea',this.search);
        var temp2 = Object.assign({}, this.search,);
        this.$api.get(`${this.apiUrl}?ExamOrganCode=${JSON.parse(this.search.ExamOrganCode).organCode}&RequestDepartment=${this.search.RequestDepartment}`).then((rsp) => {
          this.table.data = rsp.data;
          // console.log('数据333',rsp.data);
          let count_all =  rsp.data.map(item=>
            item.orderIDcount
          )
          this.count_all41 = this.sum41(count_all)
          this.$emit('sum41', this.count_all41)
          // console.log('sum41',this.count_all41);
          this.loading = false;
        });

      }
    },
    sum41(arr) {
      var s = 0;
      for (var i=arr.length-1; i>=0; i--) {
          s += arr[i];
      }
      return s;
    },
    sum(arr) {
    arr.forEach(function(value,index,array){
        array[index] == value;    //结果为true
        sum+=value;  
        });
        return sum;
    },

    //分页
    pageChange: function (page) {
      this.pagination.search.PageIndex = page;
      this.load();
    },
    sizeChange: function (size) {
      this.pagination.search.PageSize = size;
      if(this.pagination.search.PageIndex==1){
        this.load();
      }else{
        this.pagination.search.PageIndex = 1;
      }
    },
    //模态框
    openModel: function (title, path) {
      this.$refs.routerModal.openModel(title, path);
    },
    closeModel: function () {
      this.$refs.routerModal.closeModel();
    },

    //多选框触发事件
    selectionChange: function (data) {
      this.$emit("selectionChange", data);
    },
    onRowClick: function (data) {
      this.$emit("onRowClick", data);
    },
  },
};
</script>
<style scoped>
  .table_block{
    background: #fff;
    border-radius: 10px;
    padding: 15px;
  }
  .page_out{
    width: 100%;
    text-align: right;
    background-color: aqua;
    cursor: pointer;
  }
</style>
